<visa-platform-header />
<router-outlet />
<visa-platform-claim-modal />
<visa-platform-footer />
<p-toast />
<!-- <visa-platform-email-verify /> -->
